import { observer, use$ } from '@legendapp/state/react';
import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { autoBetState$ } from '../../../state';
import { ConfigureAutoBetModalContent } from './ConfigureAutoBetModalContent';

export const ConfigureAutoBetModal = observer(() => {
  const isModalOpened = use$(autoBetState$.isConfigureAutoBetModalOpen);
  const { t } = useTranslation();

  return (
    <Modal.Root
      data-test-id="configure-auto-bet-modal"
      onClose={() => autoBetState$.closeConfigureAutoBetModal()}
      opened={isModalOpened}
      size={600}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header
          bg="dark.7"
          data-test-id="configure-auto-bet-modal-header"
        >
          <Modal.Title data-test-id="configure-auto-bet-modal-title">
            {t('configureAutoBetModal.title')}
          </Modal.Title>
          <Modal.CloseButton data-test-id="configure-auto-bet-modal-close-button" />
        </Modal.Header>
        <Modal.Body bg="dark.7" data-test-id="configure-auto-bet-modal-body">
          <ConfigureAutoBetModalContent />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
});
